import { useGenericRoles } from '@infuse/iam/role/queries';
import { searchOrganisationRoles } from '@infuse/api/iam/organisation';

export const useOrganisationRoles = () => {
  return useGenericRoles({
    apiFn: searchOrganisationRoles,
    queryKeys: ['roles', 'organisation'],
    onlyEnableWithParentId: true
  });
};
